'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { AnimatePresence, motion } from 'framer-motion';
export interface SelectableOption {
  id: string | number;
  name: string;
  extraPrice?: number;
  soldOutYN?: boolean;
}
interface OptionSelectBoxProps<T extends SelectableOption> {
  options: T[];
  isOpen: boolean;
  onToggle: () => void;
  onSelectOption: (option: T) => void;
  onSoldOutClick?: () => void;
}
export const OptionSelectBox = t0 => {
  const $ = _c(29);
  const {
    options,
    isOpen,
    onToggle,
    onSelectOption,
    onSoldOutClick
  } = t0;
  const t1 = isOpen ? "border-Gray-600" : "border-Gray-300";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("max-h-[19.6875rem] overflow-y-auto border bg-Gray-white transition-colors", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isOpen && "border-b border-Gray-300";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("flex w-full items-center justify-between px-16 py-12", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isOpen ? "text-Gray-900" : "text-Gray-600";
  let t6;
  if ($[4] !== t5) {
    t6 = cn("font-400 typo-body4", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <span className={t6}>옵션을 선택해주세요.</span>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = isOpen ? "rotate-180 text-Gray-900" : "text-Gray-600";
  let t9;
  if ($[8] !== t8) {
    t9 = cn("size-16 transition-transform", t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <SvgChevrondown className={t9} />;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isOpen || $[13] !== onToggle || $[14] !== t10 || $[15] !== t4 || $[16] !== t7) {
    t11 = <button type="button" onClick={onToggle} aria-expanded={isOpen} aria-haspopup="listbox" aria-label={"\uC635\uC158 \uC120\uD0DD"} className={t4}>{t7}{t10}</button>;
    $[12] = isOpen;
    $[13] = onToggle;
    $[14] = t10;
    $[15] = t4;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isOpen || $[19] !== onSelectOption || $[20] !== onSoldOutClick || $[21] !== options) {
    t12 = isOpen && <motion.div role="listbox" initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      height: {
        duration: 0.2,
        ease: "easeOut"
      },
      opacity: {
        duration: 0.15
      }
    }} className="overflow-hidden">{options.map((option, index) => <div key={option.id}>{index > 0 && <div className="h-px bg-Gray-200" />}<button role="option" aria-selected={false} aria-disabled={option.soldOutYN === true} type="button" onClick={() => {
          if (option.soldOutYN) {
            onSoldOutClick?.();
            return;
          }
          onSelectOption(option);
        }} className={cn("w-full p-16 text-left font-400 typo-body4", option.soldOutYN ? "cursor-not-allowed bg-Gray-50 text-Gray-400" : "text-Gray-900 hover:bg-Gray-50")}>{option.name}{option.extraPrice !== undefined && option.extraPrice !== 0 && <span>{" "}({option.extraPrice > 0 ? "+" : ""}{option.extraPrice.toLocaleString()}원)</span>}</button></div>)}</motion.div>;
    $[18] = isOpen;
    $[19] = onSelectOption;
    $[20] = onSoldOutClick;
    $[21] = options;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <AnimatePresence>{t12}</AnimatePresence>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t2) {
    t14 = <div className={t2}>{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t2;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};